import React, { useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { Button } from '@spark/ui-components/components/Button';
import Icon from '@spark/ui-components/components/Icon';
import MetabaseDashboardEmbed from '@spark/ui-components/components/Dashboard/MetabaseDashboardEmbed';
import { useMetabaseDashboardToken } from '../hooks/useMetabaseDashboardToken';

const getDashboardIdFromEnv = (envValue, fallback) => {
  const parsed = Number(envValue);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

const DashboardDepositoMain = () => {
  const dashboardId = useMemo(
    () => getDashboardIdFromEnv(process.env.REACT_APP_METABASE_DASHBOARD_ID_DEPOSITO, 2),
    []
  );

  const { loading, data, error, reload } = useMetabaseDashboardToken(dashboardId);

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader  routeSegments={[{ name: 'Inicio' }, { name: 'Dashboard' }, { name: 'Deposito' }]} />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <div className="d-flex align-items-center justify-content-between mb-3">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={reload}
                  disabled={loading}
                  title="Atualizar dashboard"
                  aria-label="Atualizar dashboard"
                >
                  {loading ? (
                    <div className="spinner-border spinner-border-sm" role="status">
                      <span className="visually-hidden">Carregando...</span>
                    </div>
                  ) : (
                    <Icon name="refresh" size={18} />
                  )}
                </Button>
              </div>

              {error || !data?.token ? (
                <div className="text-muted">
                  {loading ? 'Carregando dashboard...' : 'Nao foi possivel carregar o dashboard.'}
                </div>
              ) : (
                <MetabaseDashboardEmbed
                  instanceUrl={data.instanceUrl}
                  token={data.token}
                  locale="pt-BR"
                  withTitle={false}
                  withDownloads={false}
                />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DashboardDepositoMain;
